/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Pages_Confirm_Downgrade_Title_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove pages add-on" |
*
* @param {Sub_Addons_Pages_Confirm_Downgrade_Title_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_pages_confirm_downgrade_title_remove = /** @type {((inputs?: Sub_Addons_Pages_Confirm_Downgrade_Title_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Pages_Confirm_Downgrade_Title_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Seiten-Add-on entfernen")
	return /** @type {LocalizedString} */ ("Remove pages add-on")
});